import { httpClient } from './httpClient';

export const getLogs = (params: any) => {
	return httpClient.get('/api/logs', params);
};

export const getLog = (id: any) => {
	return httpClient.get(`/api/logs/${id}`);
};

export const exportLogs = (params: any) => {
	return httpClient.get('/api/logs/action/export', params);
};

export const getFilterLog  = () => {
	return httpClient.get('/api/log/action');
};